import React from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import {
  getActiveUser,
  getActiveSchoolLicense,
  getActiveSchoolId,
  getIsFetchingLicenses,
} from 'Store/reducers';
import { fetchSchoolLicenses, fetchSchool } from 'Store/schools/actions';
import { getPlanByLicense } from 'Settings/pricing-options';

import Loading from 'Components/Loading';
import ContentFrame from 'Components/ContentFrame';
import SectionHeader from 'Components/SectionHeader';
import HeaderIcon from 'Static/icons/subscription-success.svg';
import TextBlock from 'Components/TextBlock';
import Button from 'Components/Button';
import { withRouter } from 'react-router';
import { ROUTES } from 'Settings/route-strings';

const getPlan = licenses => {
  return licenses ? getPlanByLicense(licenses[0].license_type) : undefined;
};

class PaymentConfirmation extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      fetchingPlan: false,
    };
  }

  componentDidMount() {
    /* TODO: figure out what's going on here... */
    const { schoolId, needsAuthToken, justSubscribed } = this.props;
    if (justSubscribed && !needsAuthToken) {
      this.setState({ fetchingPlan: true }, () => {
        this.props.fetchSchoolLicenses(schoolId);
        this.props.fetchSchool(schoolId);
        this.props.history.replace({
          pathname: ROUTES.SETTINGS_SUBSCRIPTION_CONFIRMATION,
          state: {},
        });
      });
    } else {
      this.props.fetchSchoolLicenses(schoolId);
      this.props.fetchSchool(schoolId);
    }
  }

  componentDidUpdate(prevProps) {
    const { licenses, isFetchingLicenses, history } = this.props;
    const plan = getPlan(licenses);
    const prevPlan = getPlan(prevProps.licenses);
    if (
      this.state.fetchingPlan &&
      plan.license_type !== prevPlan.license_type
    ) {
      this.setState({ fetchingPlan: false });
      return;
    }
    if (
      !this.state.fetchingPlan &&
      !isFetchingLicenses &&
      plan &&
      plan.availableUpgrade
    ) {
      history.push(ROUTES.SETTINGS_SUBSCRIPTION_PAYMENT);
    }
  }

  render() {
    const { activeUser, licenses, justSubscribed } = this.props;
    const plan = getPlan(licenses);

    if (!activeUser) return <Loading />;
    const NextButton = props => (
      <Button
        {...props}
        buttonType="primary"
        additionalClasses=" Button--fit-content"
        ctaIcon="caret"
      />
    );
    return (
      <main className="Page__content">
        <ContentFrame size="small" pageType="static-modal">
          <SectionHeader
            title="Thanks for subscribing!"
            type="centered"
            icon={className => <HeaderIcon className={className} />}
          />
          {justSubscribed ? (
            <TextBlock
              type="xlarge"
              description={
                <p
                  className="TextBlock__paragraph"
                  style={{ textAlign: 'center', marginTop: '0' }}
                >
                  We’ll send you an email shortly with all the transaction
                  details.
                </p>
              }
            />
          ) : null}
          <div
            style={{
              display: 'flex',
              justifyContent: 'center',
              marginTop: '4em',
              width: '100%',
            }}
          >
            <NextButton label="Explore the apps" route={ROUTES.EXPLORE} />
          </div>
        </ContentFrame>
      </main>
    );
  }
}

PaymentConfirmation.propTypes = {
  schoolId: PropTypes.number,
  justSubscribed: PropTypes.bool.isRequired,
  needsAuthToken: PropTypes.bool.isRequired,
  isFetchingLicenses: PropTypes.bool.isRequired,
  fetchSchoolLicenses: PropTypes.func.isRequired,
  fetchSchool: PropTypes.func.isRequired,
  licenses: PropTypes.array,
  history: PropTypes.shape({
    replace: PropTypes.func,
    push: PropTypes.func,
  }),
  activeUser: PropTypes.object,
};

const mapStateToProps = (state, { location }) => {
  return {
    justSubscribed:
      typeof location.state !== 'undefined' &&
      location.state.justSubscribed === true,
    needsAuthToken:
      typeof location.state !== 'undefined' &&
      location.state.needsAuthToken === true,
    activeUser: getActiveUser(state),
    schoolId: getActiveSchoolId(state),
    licenses: getActiveSchoolLicense(state),
    isFetchingLicenses: getIsFetchingLicenses(state),
  };
};

export default withRouter(
  connect(mapStateToProps, { fetchSchoolLicenses, fetchSchool })(
    PaymentConfirmation
  )
);
